// Copyright (c) 2017 Deere & Company

import t from 'tcomb';

const ReimbursementSummaryClaimSummaryData = t.struct({
    data: t.list(t.Object)
}, 'ReimbursementSummaryClaimSummaryData');

export const getDefaultState = () =>
    new ReimbursementSummaryClaimSummaryData({
        data: []
    });

export default ReimbursementSummaryClaimSummaryData;




// WEBPACK FOOTER //
// ./src/reimbursement-summary/claims/state/claim-summary.js